import { Box, Divider as BaseDivider } from '@mui/material';
import { styled } from '@mui/material/styles';
import { withDefaults } from '../../../../utils/withDefaults';
export const Card = styled(Box)(({
  theme
}) => ({
  cursor: 'pointer',
  background: theme.palette.common.white,
  borderRadius: theme.spacing(1),
  boxShadow: theme.shadows[3],
  padding: theme.spacing(2)
}));
export const Conditions = styled(Box)(({
  theme
}) => ({
  display: 'flex',
  marginTop: theme.spacing(2)
}));
const ItemRoot = styled(Box)({});
export const Item = withDefaults(ItemRoot, {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
});
const DividerRoot = styled(BaseDivider)(({
  theme
}) => ({
  height: theme.spacing(4)
}));
export const Divider = withDefaults(DividerRoot, {
  orientation: 'vertical'
});
export const Frame = styled(Box)(({
  theme
}) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1.5)
}));